import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators,
} from '@angular/forms';

import { FormControl } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YY',
  },
  display: {
    dateInput: 'MM/YY',
    monthYearLabel: 'MMM YY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'form-input-credit-card-expiration',
  templateUrl: './input-credit-card-expiration.component.html',
  styleUrls: ['./input-credit-card-expiration.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCreditCardExpirationComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputCreditCardExpirationComponent),
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class InputCreditCardExpirationComponent
  implements OnInit, ControlValueAccessor, Validators
{
  @Input() id = '';
  @Input() type = 'text';
  @Input() label = '';
  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() minDate: Date = new Date();

  public date: FormControl<Moment> = new FormControl();
  public value: { month: string; year: string };
  private _onChange = (_: any) => {};
  private _onTouch = () => {};

  constructor() {}

  ngOnInit(): void {}

  public chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this._setValue(ctrlValue);
    this.date.setValue(ctrlValue);
  }

  public chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    this._setValue(ctrlValue);
    datepicker.close();
  }

  private _setValue(ctrlValue: _moment.Moment): void {
    const month = ctrlValue.month() + 1;
    const year = ctrlValue.year().toString().slice(-2);
    this.value = {
      month: month <= 9 ? `0${month}` : month.toString(),
      year,
    };
    this._onChange(this.value);
  }

  public initPicker(datepicker: MatDatepicker<Moment>) {
    if (!this.date.value) {
      this.date.setValue(moment());
    }
    datepicker.open();
    this._onTouch();
  }

  public writeValue(value: any): void {
    // TODO:Review to implement date on init input
    // this.value = {};
  }

  public registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }

  public setDisabledState?(disabled: boolean): void {
    this.disabled = disabled;
  }

  validate(): ValidationErrors | null {
    const date = new Date(this.date.value?.toISOString());
    const validDate = this.minDate < date;
    return !validDate ? { dateInvalid: true } : null;
  }
}
